import React from "react";
import Grid from "@material-ui/core/Grid";
import useStyles from "./styles";

export default function CompoundViewTable({compounds, hideHeader = false, style, row}) {

    const classes = useStyles();

    return <Grid key={row} item className={style}>
        {!hideHeader && <><b>Compound Information:</b><br/></>}
        <table width="800px">
            <thead>
            <tr>
                <th width="40px"/>
                <th className={classes.center}>ID Qualifier</th>
                <th className={classes.center}>Product ID(NDC)</th>
                <th className={classes.center}>Ingredient Quantity</th>
            </tr>
            </thead>
            <tbody>
            {compounds && compounds.map((compound, i) => 
                <>
                    { compound.productId && compound.ingredientQty &&
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td className={classes.center}>NDC</td>
                            <td className={classes.center}>{compound.productId}</td>
                            <td className={classes.center}>{compound.ingredientQty}</td>
                        </tr>
                    }
                </>
            )}
            </tbody>
        </table>
    </Grid>
}
